import { render } from "./ComsumeRemarkDialog.vue?vue&type=template&id=4d6d0e31"
import script from "./ComsumeRemarkDialog.vue?vue&type=script&lang=js"
export * from "./ComsumeRemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__